import Clarity from '@microsoft/clarity';
import { auth } from '@/store/authStore';

function isClarityEnabled(): boolean {
  return Boolean(process.env.REACT_APP_CLARITY_PROJECT_ID?.trim());
}

/**
 * Initializes Microsoft Clarity when REACT_APP_CLARITY_PROJECT_ID is set.
 * Create a project and copy the ID from https://clarity.microsoft.com/
 */
export function initClarity(): void {
  const projectId = process.env.REACT_APP_CLARITY_PROJECT_ID?.trim();
  if (!projectId) {
    return;
  }
  try {
    Clarity.init(projectId);
  } catch (error) {
    console.error('Failed to initialize Microsoft Clarity:', error);
  }
}

/**
 * Links the current Clarity session to the signed-in user for filtering in the dashboard.
 * Passes email as custom-id (hashed by Clarity on the client before upload). See:
 * https://learn.microsoft.com/en-us/clarity/setup-and-installation/identify-api
 *
 * Call again on route changes (recommended by Microsoft) and after auth updates.
 */
export function syncClarityIdentify(): void {
  if (!isClarityEnabled() || typeof window === 'undefined') {
    return;
  }

  const user = auth.getUser();
  if (!user.isAuthenticated) {
    return;
  }

  const email = user.email?.trim();
  const customId = email || user.userId?.trim();
  if (!customId) {
    return;
  }

  const friendlyName = user.name?.trim() || email || undefined;
  const pageId =
    typeof window !== 'undefined' ? `${window.location.pathname}${window.location.search}` : undefined;

  try {
    Clarity.identify(customId, undefined, pageId, friendlyName);
  } catch (error) {
    console.error('Clarity identify failed:', error);
  }
}
